import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const parseAnswersIfNeeded = (answers) => {
  if (typeof answers === "string") {
    try {
      return JSON.parse(answers);
    } catch (e) {
      console.error("Error parsing answers in AdminQuizCard:", e);
      return [];
    }
  }
  return Array.isArray(answers) ? answers : [];
};

const AdminQuizCard = ({ quiz, onEdit, onDelete }) => {
  const { t } = useTranslation("learningPaths");
  const answers = parseAnswersIfNeeded(quiz.answers);
  return (
    <div className="admin-card-quiz">
      <div className="d-flex gap-2 mb-3 flex-column flex-sm-row align-items-start justify-content-between">
        <h3 className="font_20 font-extrabold"> {quiz.title} </h3>
        <div className="d-flex gap-2">
          {onEdit && (
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => onEdit(quiz)}
            >
              <i className="fas fa-edit me-2" aria-hidden />
              {t("learningPaths:editQuestion")}
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() => onDelete(quiz)}
            >
              <i className="fas fa-trash-alt me-2" aria-hidden />
              {t("learningPaths:deleteQuestion")}
            </button>
          )}
        </div>
      </div>
      <ul className="admin-card-quiz__answers">
        {answers.length > 0 ? (
          answers.map((answer, i) => (
            <li
              key={answer.id}
              className={`admin-card-quiz__answer d-flex align-items-center ${
                answer.isCorrect ? "admin-card-quiz__answer--correct" : ""
              }`}
            >
              <div className="admin-card-quiz__answer-body d-flex min-w-0">
                <span className="font-color-grey-light font_16 font-extrabold flex-shrink-0">
                  {i + 1}-{" "}
                </span>
                <p className="font_16 font-bold px-3 mb-0 text-break">
                  {answer.title}
                </p>
              </div>
              {answer.isCorrect && (
                <span className="label label-green admin-card-quiz__answers__correct font-bold flex-shrink-0">
                  <i className="fas fa-check-circle" aria-hidden="true" />
                  <span className="admin-card-quiz__answers__correct-text">
                    {t("learningPaths:rightAnswer")}
                  </span>
                </span>
              )}
            </li>
          ))
        ) : (
          <li className="text-muted">{t("learningPaths:noAnswersAdded")}</li>
        )}
      </ul>
    </div>
  );
};

export default AdminQuizCard;

AdminQuizCard.propTypes = {
  quiz: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    course: PropTypes.string,
    lesson: PropTypes.string,
    time: PropTypes.string,
    answers: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  }),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};
